// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let totalSupply = await store
        .getState()
        .blockchain.smartContract.methods.totalSupply()
        .call();
        let maxSupply = await store
        .getState()
        .blockchain.smartContract.methods.maxSupply()
        .call();
        let normalPrice = await store
        .getState()
        .blockchain.smartContract.methods.normalPrice()
        .call();
        let whitelistPrice = await store
        .getState()
        .blockchain.smartContract.methods.whitelistPrice()
        .call();
        let memberPrice = await store
        .getState()
        .blockchain.smartContract.methods.memberPrice()
        .call();
      // let cost = await store
      //   .getState()
      //   .blockchain.smartContract.methods.cost()
      //   .call();

      dispatch(
        fetchDataSuccess({
          totalSupply,
          maxSupply,
          normalPrice,
          whitelistPrice,
          memberPrice,
          // cost,
        })
      );
    } catch (err) {
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
